var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegularCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.6832C2 6.66621 2 5.15772 2.93726 4.22046C3.87452 3.2832 5.38301 3.2832 8.4 3.2832H11.6C14.617 3.2832 16.1255 3.2832 17.0627 4.22046C18 5.15772 18 6.66621 18 9.6832V11.2832C18 14.3002 18 15.8087 17.0627 16.7459C16.1255 17.6832 14.617 17.6832 11.6 17.6832H8.4C5.38301 17.6832 3.87452 17.6832 2.93726 16.7459C2 15.8087 2 14.3002 2 11.2832V9.6832Z",
    stroke: "#344266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00098 3.28398V2.08398",
    stroke: "#344266",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.28398V2.08398",
    stroke: "#344266",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40137 7.2832H17.6014",
    stroke: "#344266",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8012 13.6836C14.8012 14.1254 14.443 14.4836 14.0012 14.4836C13.5593 14.4836 13.2012 14.1254 13.2012 13.6836C13.2012 13.2418 13.5593 12.8836 14.0012 12.8836C14.443 12.8836 14.8012 13.2418 14.8012 13.6836Z",
    fill: "#344266"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8012 10.4836C14.8012 10.9254 14.443 11.2836 14.0012 11.2836C13.5593 11.2836 13.2012 10.9254 13.2012 10.4836C13.2012 10.0418 13.5593 9.68359 14.0012 9.68359C14.443 9.68359 14.8012 10.0418 14.8012 10.4836Z",
    fill: "#344266"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8002 13.6836C10.8002 14.1254 10.442 14.4836 10.0002 14.4836C9.55837 14.4836 9.2002 14.1254 9.2002 13.6836C9.2002 13.2418 9.55837 12.8836 10.0002 12.8836C10.442 12.8836 10.8002 13.2418 10.8002 13.6836Z",
    fill: "#344266"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8002 10.4836C10.8002 10.9254 10.442 11.2836 10.0002 11.2836C9.55837 11.2836 9.2002 10.9254 9.2002 10.4836C9.2002 10.0418 9.55837 9.68359 10.0002 9.68359C10.442 9.68359 10.8002 10.0418 10.8002 10.4836Z",
    fill: "#344266"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8002 13.6836C6.8002 14.1254 6.44202 14.4836 6.0002 14.4836C5.55837 14.4836 5.2002 14.1254 5.2002 13.6836C5.2002 13.2418 5.55837 12.8836 6.0002 12.8836C6.44202 12.8836 6.8002 13.2418 6.8002 13.6836Z",
    fill: "#344266"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8002 10.4836C6.8002 10.9254 6.44202 11.2836 6.0002 11.2836C5.55837 11.2836 5.2002 10.9254 5.2002 10.4836C5.2002 10.0418 5.55837 9.68359 6.0002 9.68359C6.44202 9.68359 6.8002 10.0418 6.8002 10.4836Z",
    fill: "#344266"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularCalendar);
export default __webpack_public_path__ + "static/media/RegularCalendar.d55728288541a0f7f897e37b898a36e2.svg";
export { ForwardRef as ReactComponent };